import type {FunctionComponent} from 'react';
import {useMemo} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

import {LandingSection} from '@tempo/landing';
import type {Article} from '@app/components/faq';
import {LandingSeoFaq} from '@app/components/faq';

export const FAQ: FunctionComponent = () => {
	const {t} = useTranslation();

	const articles = useMemo<Article[]>(
		() => [
			{
				title: t(
					'musicquizlandingpage_text_QhowcaniplayXfeaturename_standalone-web',
					{ns: 'musicquiz'},
				),
				answer: [
					t('musicquizlandingpage_text_AhowcaniplayXname_standalone-web', {
						ns: 'musicquiz',
					}),
				],
			},
			{
				title: t(
					'musicquizlandingpage_text_QisthereaXfeaturenameapp_standalone-web',
					{ns: 'musicquiz'},
				),
				answer: [
					t(
						'musicquizlandingpage_text_AisthereaXfeaturenameapp_standalone-web',
						{ns: 'musicquiz'},
					),
				],
			},
			{
				title: t(
					'musicquizlandingpage_text_Qwherecanifindgameonapp_standalone-web',
					{ns: 'musicquiz'},
				),
				answer: [
					t(
						'musicquizlandingpage_text_Awherecanifindgameonapp_standalone-web',
						{ns: 'musicquiz'},
					),
				],
			},
			{
				title: t(
					'musicquizlandingpage_text_Qhowdoisharemyscore_standalone-web',
					{ns: 'musicquiz'},
				),
				answer: [
					t('musicquizlandingpage_text_Ahowdoisharemyscore_standalone-web', {
						ns: 'musicquiz',
					}),
				],
			},
		],
		[t],
	);
	return (
		<LandingSection isContained>
			<LandingSeoFaq articles={articles} />
		</LandingSection>
	);
};
